import React, { useMemo } from 'react'
import { useSelector } from 'react-redux'

import InventoryItemSection from '../InventoryItemSection'
import InventorySectionHeader from '../AllInventorySection/InventorySectionHeader'
import InventoryAvailability from '../InventoryAvailability'

import {
  getInventoryItemId,
  getInventoryItemIdFieldName
} from '../../../../../../../forms/GAM/UploadGamAdCreative/UploadGamAdCreativeForm/LineItemForm/helpers'
import { isAdInventoryTargetingEnabled } from '../../../../../../../forms/GAM/UploadGamAdCreative/UploadGamAdCreativeForm/LineItemForm/formatters/formatInventoryTargeting'
import { getAllocationInfo } from '../../../../../../../forms/Multiplatform/Partnerships/RightForms/RightCreate/RightCreateForm/sectionsLists/OnsiteRightCreateSections/GamOnsiteRightCreateSections/helpers'
import { useSubAllocationRemainingBudget } from '../../../../../../../forms/GAM/UploadGamAdCreative/UploadGamAdCreativeForm/LineItemForm/hooks/remainingBudgetHooks'

import { rightSelector } from '../../../../../../../modules/selectors/rights'

import {
  AD_INVENTORY,
  IS_SUB_ALLOCATION,
  SUB_ALLOCATION
} from '../../../../../../../forms/Multiplatform/Partnerships/RightForms/RightCreate/RightCreateForm/sectionsLists/OnsiteRightCreateSections/fields'

const IndividualInventorySections = () => {
  const right = useSelector(rightSelector)
  const inventory = right[AD_INVENTORY]
  const { isPercentageAllocation } = getAllocationInfo(right)
  const adInventoryTargetingEnabled = isAdInventoryTargetingEnabled(right)
  const isSubAllocation = right[IS_SUB_ALLOCATION]
  const subAllocation = right[SUB_ALLOCATION]

  const inventoryBudgets = useSubAllocationRemainingBudget()

  const showRemaining = useMemo(() => {
    if (isPercentageAllocation) {
      // if targeting disabled we show remaining days on the main "All inventory" section
      return adInventoryTargetingEnabled
    } else {
      return isSubAllocation
    }
  }, [isPercentageAllocation, isSubAllocation, adInventoryTargetingEnabled])

  return inventory.map(inventoryItem => {
    const allocation = subAllocation?.find(
      item => item[getInventoryItemIdFieldName(item)] === getInventoryItemId(inventoryItem)
    )?.allocation

    return (
      <InventoryItemSection
        name={inventoryItem.name}
        key={getInventoryItemId(inventoryItem)}
        headerChildren={
          <InventorySectionHeader
            // single inventory item
            inventory={[inventoryItem]}
            // Show percentage allocation on separate inventory sections only for sub-allocation rights
            showAllocation={isSubAllocation}
            showRemaining={showRemaining}
            allocation={allocation}
            remainingBudget={inventoryBudgets[getInventoryItemId(inventoryItem)]?.remaining}
          />
        }
      >
        <InventoryAvailability inventory={[inventoryItem]} showInventoryTimelines={isPercentageAllocation} />
      </InventoryItemSection>
    )
  })
}

export default IndividualInventorySections
